function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { ThemeProvider } from 'styled-components';
import { getPubSub } from '@keen.io/pubsub';
import { screenBreakpoints } from '@keen.io/ui-core';
import KeenAnalysis from 'keen-analysis';
import App from './App';
import { GlobalStyles } from './components';
import rootSaga from './saga';
import rootReducer from './reducer';
import { rehydrateState } from './rehydrateState';
import { AppContext } from './contexts';
import { appStart, getQueryReadiness } from './modules/app';
import { getQuery, serializeQuery, resetQuery } from './modules/query';
import { updateChartSettings } from './modules/chartSettings';
import { transformToQuery, transformQueryToCamelCase } from './utils';
import { UPDATE_TIMEOUT, SET_QUERY_EVENT, NEW_QUERY_EVENT, SET_CHART_SETTINGS, UPDATE_VISUALIZATION_TYPE, QUERY_UPDATE_ACTION, ANALYTICS_API_HOST, TIMEZONES_API_HOST, HTTP_PROTOCOL } from './constants';
import { createConfiguration } from './createConfiguration';

var QueryCreator = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(QueryCreator, _React$PureComponent);

  var _super = _createSuper(QueryCreator);

  function QueryCreator(props) {
    var _context;

    var _this;

    _classCallCheck(this, QueryCreator);

    _this = _super.call(this, props);

    _this.runQueryListener = function () {
      var onUpdateQuery = _this.props.onUpdateQuery;
      _this.storeSubscription = _this.store.subscribe(function () {
        var state = _this.store.getState();

        var isQueryReady = getQueryReadiness(state);
        var query = getQuery(state);

        if (onUpdateQuery && state.lastAction.type.includes(QUERY_UPDATE_ACTION)) {
          if (_this.updateQueryTrigger) clearTimeout(_this.updateQueryTrigger);
          _this.updateQueryTrigger = setTimeout(function () {
            onUpdateQuery(transformToQuery(query), isQueryReady);
          }, UPDATE_TIMEOUT);
        }
      });
    };

    _this.subscribeSetQuery = function () {
      _this.setQuerySubscription = _this.pubsub.subscribe(function (eventName, meta) {
        switch (eventName) {
          case NEW_QUERY_EVENT:
            var _this$store$getState = _this.store.getState(),
                defaultTimezoneForQuery = _this$store$getState.timezone.defaultTimezoneForQuery;

            _this.store.dispatch(resetQuery(defaultTimezoneForQuery));

            break;

          case SET_QUERY_EVENT:
            var query = meta.query;
            var transformedQuery = transformQueryToCamelCase(query);

            _this.store.dispatch(serializeQuery(transformedQuery));

            break;

          case SET_CHART_SETTINGS:
            var chartSettings = meta.chartSettings;

            _this.store.dispatch(updateChartSettings(chartSettings));

            break;

          case UPDATE_VISUALIZATION_TYPE:
            var _this$store$getState2 = _this.store.getState(),
                settings = _this$store$getState2.chartSettings;

            _this.props.onUpdateChartSettings(settings);

            break;

          default:
            break;
        }
      });
    };

    _this.keenClient = new KeenAnalysis({
      projectId: _this.props.projectId,
      masterKey: _this.props.masterKey,
      readKey: _this.props.readKey,
      host: _this.props.host,
      protocol: _this.props.httpProtocol
    });
    var sagaMiddleware = createSagaMiddleware({
      context: (_context = {}, _defineProperty(_context, HTTP_PROTOCOL, _this.props.httpProtocol), _defineProperty(_context, "keenClient", _this.keenClient), _defineProperty(_context, ANALYTICS_API_HOST, _this.props.host), _defineProperty(_context, TIMEZONES_API_HOST, _this.props.timezonesHost), _context)
    });
    var preloadedState = rehydrateState();
    var initialState = createConfiguration(preloadedState, _this.props.defaultTimezoneForQuery, !!_this.props.disableTimezoneSelection);
    _this.store = createStore(rootReducer, initialState, applyMiddleware(sagaMiddleware));
    sagaMiddleware.run(rootSaga);

    _this.store.dispatch(appStart());

    _this.pubsub = getPubSub();

    _this.runQueryListener();

    _this.subscribeSetQuery();

    return _this;
  }

  _createClass(QueryCreator, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.storeSubscription) this.storeSubscription();
      if (this.setQuerySubscription) this.setQuerySubscription();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Provider, {
        store: this.store
      }, React.createElement(GlobalStyles, {
        modalContainer: this.props.modalContainer
      }), React.createElement(ThemeProvider, {
        theme: {
          breakpoints: screenBreakpoints
        }
      }, React.createElement(AppContext.Provider, {
        value: {
          modalContainer: this.props.modalContainer,
          onUpdateChartSettings: this.props.onUpdateChartSettings,
          keenClient: this.keenClient,
          disableFilterSuggestions: this.props.disableFilterSuggestions
        }
      }, React.createElement(App, null))));
    }
  }]);

  return QueryCreator;
}(React.PureComponent);

QueryCreator.defaultProps = {
  httpProtocol: 'https',
  timezonesHost: 'api.keen.io'
};
export default QueryCreator;